import React from 'react';
import { motion } from 'framer-motion';
import { FaBook, FaGamepad, FaFilm, FaGlobe, FaUsers, FaPalette } from 'react-icons/fa';

export const TransformationShowcase = () => {
  const features = [
    {
      title: "Multi-Format Publishing",
      icon: <FaBook className="text-3xl" />,
      description: "Transform your narrative into books, scripts, games, or graphic novels while maintaining perfect consistency.",
      color: "from-blue-400 to-purple-500"
    },
    {
      title: "Audience Adaptation",
      icon: <FaUsers className="text-3xl" />,
      description: "Automatically adjust content rating and reading levels while preserving your story's essence.",
      color: "from-purple-400 to-pink-500"
    },
    {
      title: "Cultural Localization",
      icon: <FaGlobe className="text-3xl" />,
      description: "Reimagine your stories for different cultures while maintaining their core themes and impact.",
      color: "from-pink-400 to-red-500"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="py-20 px-4">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
        className="max-w-7xl mx-auto"
      >
        <div className="text-center mb-16">
          <motion.h2 
            variants={itemVariants}
            className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400"
          >
            Transform Stories Across Any Medium
          </motion.h2>
          <motion.p 
            variants={itemVariants}
            className="text-xl text-gray-300 max-w-3xl mx-auto"
          >
            With NarrativeForge™, your story becomes a living dataset ready to adapt across formats, audiences, and cultures.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-r opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-xl"></div>
              <div className="relative p-8 rounded-xl bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 h-full transform transition-transform hover:shadow-2xl">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r ${feature.color} mb-6`}>
                  {feature.icon}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-white">{feature.title}</h3>
                <p className="text-gray-300">{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          variants={itemVariants}
          className="mt-16 flex justify-center"
        >
          <div className="inline-flex gap-4 p-4 rounded-xl bg-gray-800/30 backdrop-blur-sm border border-gray-700/50">
            <FaBook className="text-2xl text-blue-400" />
            <FaGamepad className="text-2xl text-purple-400" />
            <FaFilm className="text-2xl text-pink-400" />
            <FaPalette className="text-2xl text-red-400" />
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};
